"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enumDirectionClass = exports.enumDirection = void 0;

/**
 * @desc
 * Radio button list direction.
 *
 * @enum
 *
 * @type {{HORIZONTAL: string, VERTICAL: string}}
 */
var enumDirection = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
/**
 * @desc
 * Radio button list direction classes.
 *
 * @enum
 *
 * @type {{HORIZONTAL: string, VERTICAL: string}}
 */

exports.enumDirection = enumDirection;
var enumDirectionClass = {
  HORIZONTAL: 'fl-container fl-container-row horizontal-radio-buttons',
  VERTICAL: 'fl-container fl-container-column vertical-radio-buttons'
};
exports.enumDirectionClass = enumDirectionClass;
//# sourceMappingURL=constants.js.map